/**
 * @description Import type
 * @type {{SCRIPT= string, STYLE= string}}
 */
export enum ImportType {

	/**
	 * @description Script
	 */
	SCRIPT = 'script',

	/**
	 * @description Style
	 */
	STYLE = 'style'

}